<template>
    <el-form :model="searchArr" ref="searchForm" label-width="115px" id="call-task-resource-form-horizontal">
        <el-form-item label="客户回复:" width="500px" prop="answer">
            <el-checkbox v-model="searchArr.answer" border size="mini">客户最新回复消息</el-checkbox>
        </el-form-item>
        <el-form-item label="是否微信:" width="500px" prop="is_wechat">
            <el-checkbox-group v-model="searchArr.is_wechat">
                <el-checkbox false-label="" true-label="1" name="status">是微信</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">非微信</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="有无渠道手机号:" width="500px" prop="has_xlb_phone">
            <el-checkbox-group v-model="searchArr.has_xlb_phone">
                <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="有无清洗手机号:" width="500px" prop="has_self_phone">
            <el-checkbox-group v-model="searchArr.has_self_phone">
                <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="线索状态:" width="500px" prop="clue_status">
            <el-checkbox-group v-model="searchArr.clue_status">
                <el-checkbox false-label="" true-label="1" name="status">已经沟通</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">未沟通</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否有效沟通:" width="500px" prop="effect">
            <el-checkbox-group v-model="searchArr.effect">
                <el-checkbox false-label="" true-label="1" name="status">是</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">否</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="客户意向:" width="500px" prop="satisfy">
            <el-checkbox-group v-model="searchArr.satisfy">
                <el-checkbox label="1">A</el-checkbox>
                <el-checkbox label="2">B</el-checkbox>
                <el-checkbox label="3">C</el-checkbox>
                <el-checkbox label="4">D</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否会员:" width="500px" prop="is_member">
            <el-checkbox-group v-model="searchArr.is_member">
                <el-checkbox false-label="" true-label="1" name="status">是</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">否</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否订单:" width="500px" prop="is_order">
            <el-checkbox-group v-model="searchArr.is_order">
                <el-checkbox false-label="" true-label="1" name="status">是</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">否</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="有无资质证书:" width="500px" prop="is_zz">
            <el-checkbox-group v-model="searchArr.is_zz">
                <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="有无基础信息:" width="500px" prop="base">
            <el-checkbox-group v-model="searchArr.base">
                <el-checkbox false-label="" true-label="1" name="status">有</el-checkbox>
                <el-checkbox false-label="" true-label="2" name="status">无</el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="公司名称过长:" width="500px" prop="un_send">
            <el-checkbox v-model="searchArr.un_send" size="mini"></el-checkbox>
        </el-form-item>

        <!-- <el-form-item label="创建时间" prop="created_at">
                            <el-date-picker size="mini" v-model="searchArr.created_at" type="datetimerange"
                                align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期" :picker-options="ysyTypeInPickerOptions"
                                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </el-form-item>-->
        <el-form-item style="text-align: right; margin-right: 0.3rem">
            <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
            <el-button type="primary" @click="doSearch" size="mini">查询</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: 'HavingData',
    data() {
        return {
            searchArr: {
                answer: null,
                is_wechat: '',
                has_xlb_phone: '',
                has_self_phone: '',
                clue_status: '',
                effect: '',
                satisfy: [],
                un_send: null,
                is_member: '',
                is_order: '',
                is_zz: '',
                base: ''
            },
        }
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        doSearch() {
            this.$emit('doSearch', this.searchArr)
        },
    },
    mounted() {
    }
}
</script>

<style scoped>
#call-task-resource-form-horizontal >>> .el-form-item {
    margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/cloudClue/Components/HavingData.vue